import {
  AgentPipelineModel,
  AllDepartmentsPipelineModel,
  CustomerModel,
  DashboardPipelineModel,
  DepartmentPipelineModel,
  PipelineActivityType,
  SalesHierarchyModel,
  ValCallResult,
} from "@/models/pipeline";
import { WIPStatus } from "@/models/pipeline/WIPModel";
import { AllocationSkillResponse, AvailableSkill, UserSkillAssignment } from "@/types/allocations";

export const mockWarmCustomers: CustomerModel[] = [
  {
    applicationId: 40001,
    customerName: "Emily Watson",
    agentName: "Agent 1",
    allocatedOn: "2025-01-10",
    quotesTotalCount: 3,
    quoteStatus: "Pending",
    lastTouch: "2025-01-11T14:30:00",
    handoverAllocatedUserId: null,
    handoverToUserId: null,
    customerLastOnlineTime: "2025-01-12T09:15:00",
    conversationsTotalCount: 5,
    conversationsOutboundCount: 3,
    conversationsInboundCount: 2,
    activities: [
      {
        actitivityTypeId: PipelineActivityType.SavedQuote,
        activityTypeName: "Email Sent",
        activityTime: "2025-01-11T14:30:00",
      },
    ],
    daysOld: 2,
    isPredictedToDoc: true,
    lastNote: "Customer interested in BMW 3 Series",
  },
  {
    applicationId: 40002,
    customerName: "James Thompson",
    agentName: "Agent 2",
    allocatedOn: "2025-01-09",
    quotesTotalCount: 2,
    quoteStatus: "Approved",
    lastTouch: "2025-01-10T11:00:00",
    handoverAllocatedUserId: null,
    handoverToUserId: null,
    customerLastOnlineTime: "2025-01-11T16:45:00",
    conversationsTotalCount: 8,
    conversationsOutboundCount: 5,
    conversationsInboundCount: 3,
    activities: [
      {
        actitivityTypeId: PipelineActivityType.SavedQuote,
        activityTypeName: "Call Made",
        activityTime: "2025-01-10T11:00:00",
      },
    ],
    daysOld: 3,
    isPredictedToDoc: false,
    lastNote: "Waiting for proof of address",
  },
  {
    applicationId: 40003,
    customerName: "Sophie Miller",
    agentName: "Agent 3",
    allocatedOn: "2025-01-08",
    quotesTotalCount: 1,
    quoteStatus: null,
    lastTouch: "2025-01-09T16:20:00",
    handoverAllocatedUserId: null,
    handoverToUserId: null,
    customerLastOnlineTime: null,
    conversationsTotalCount: 3,
    conversationsOutboundCount: 2,
    conversationsInboundCount: 1,
    activities: [
      {
        actitivityTypeId: PipelineActivityType.SavedQuote,
        activityTypeName: "SMS Sent",
        activityTime: "2025-01-09T16:20:00",
      },
    ],
    daysOld: 4,
    isPredictedToDoc: true,
    lastNote: null,
  },
];

export const mockCustomers: CustomerModel[] = [
  {
    applicationId: 50001,
    customerName: "Oliver Davis",
    agentName: "Agent 1",
    allocatedOn: "2025-01-05",
    quotesTotalCount: 0,
    quoteStatus: null,
    lastTouch: "2025-01-06T10:15:00",
    handoverAllocatedUserId: null,
    handoverToUserId: null,
    customerLastOnlineTime: "2025-01-07T12:00:00",
    conversationsTotalCount: 2,
    conversationsOutboundCount: 2,
    conversationsInboundCount: 0,
    activities: [],
    daysOld: 7,
    isPredictedToDoc: false,
    lastNote: "Left voicemail",
  },
  {
    applicationId: 50002,
    customerName: "Charlotte Wilson",
    agentName: "Agent 2",
    allocatedOn: "2025-01-03",
    quotesTotalCount: 4,
    quoteStatus: "Declined",
    lastTouch: "2025-01-08T09:30:00",
    handoverAllocatedUserId: null,
    handoverToUserId: null,
    customerLastOnlineTime: "2025-01-10T14:20:00",
    conversationsTotalCount: 10,
    conversationsOutboundCount: 6,
    conversationsInboundCount: 4,
    activities: [
      {
        actitivityTypeId: PipelineActivityType.SavedQuote,
        activityTypeName: "Quote Sent",
        activityTime: "2025-01-08T09:30:00",
      },
    ],
    daysOld: 9,
    isPredictedToDoc: false,
    lastNote: "Needs better rate",
  },
  {
    applicationId: 50003,
    customerName: "George Taylor",
    agentName: "Agent 3",
    allocatedOn: "2025-01-01",
    quotesTotalCount: 2,
    quoteStatus: "Pending",
    lastTouch: null,
    handoverAllocatedUserId: null,
    handoverToUserId: null,
    customerLastOnlineTime: null,
    conversationsTotalCount: 1,
    conversationsOutboundCount: 1,
    conversationsInboundCount: 0,
    activities: [],
    daysOld: 11,
    isPredictedToDoc: false,
    lastNote: null,
  },
];

export const mockAgentPipelineData: AgentPipelineModel = {
  statistics: {
    leadsToday: 3,
    leadsTotal: 15,
    predictedToDocs: 2,
    docsToday: 1,
    gapDocsOut: 2,
    gapReadyToGo: 1,
    gapPayout: 0,
    gapTotal: 3,
    predictedToPay: 1,
    paidToday: 0,
  },
  valCalls: [
    {
      applicationId: 12345,
      customerName: "John Smith",
      paidOutDate: "2025-01-10",
      dealerValCallCompletedDate: null,
      customerValCallCompletedDate: null,
      customerValCallNonFranchisedCompletedDate: null,
      dealerValCallResult: ValCallResult.Completed,
      customerValCall1Result: ValCallResult.Completed,
      customerValCall2Result: ValCallResult.NotCompleted,
      handoverAllocatedUserId: null,
      handoverToUserId: null,
    },
    {
      applicationId: 12346,
      customerName: "Jane Doe",
      paidOutDate: "2025-01-09",
      dealerValCallCompletedDate: null,
      customerValCallCompletedDate: null,
      customerValCallNonFranchisedCompletedDate: null,
      dealerValCallResult: ValCallResult.Completed,
      customerValCall1Result: ValCallResult.NotCompleted,
      customerValCall2Result: ValCallResult.NotRequired,
      handoverAllocatedUserId: null,
      handoverToUserId: null,
    },
  ],
  wip: [
    {
      applicationId: 22345,
      allocatedAgentName: "Agent One",
      customerName: "Michael Brown",
      isPredictedToPay: true,
      allocatedPayoutAgent: "Payout Agent 1",
      status: WIPStatus.DocsOut,
      customerDocsStatus: "Awaiting",
      dealerDocsStatus: "Received",
      financeDocsStatus: "Awaiting",
      handoverAllocatedUserId: null,
      handoverToUserId: null,
    },
    {
      applicationId: 22346,
      allocatedAgentName: "Agent Two",
      customerName: "Sarah Wilson",
      isPredictedToPay: false,
      allocatedPayoutAgent: "Payout Agent 2",
      status: WIPStatus.AwaitingPayout,
      customerDocsStatus: "Complete",
      dealerDocsStatus: "Complete",
      financeDocsStatus: "Complete",
      handoverAllocatedUserId: null,
      handoverToUserId: null,
    },
  ],
  customersWarm: mockWarmCustomers,
  customers: mockCustomers,
};

export const mockDepartmentPipelineData: DepartmentPipelineModel = {
  statistics: {
    leadsToday: 12,
    leadsTotal: 45,
    predictedToDocs: 5,
    docsToday: 3,
    gapDocsOut: 4,
    gapReadyToGo: 2,
    gapPayout: 1,
    gapTotal: 7,
    predictedToPay: 3,
    paidToday: 1,
  },
  valCalls: mockAgentPipelineData.valCalls,
  wip: mockAgentPipelineData.wip,
  customersWarm: mockWarmCustomers,
  customers: mockCustomers,
  deals: [],
  handovers: [
    {
      handoverId: 1,
      applicationId: 33345,
      customerName: "Robert Johnson",
      allocatedToUserId: 100,
      allocatedToUserName: "Agent 1",
      handoverToUserId: 101,
      handoverToUserName: "Agent 2",
      note: "Customer prefers morning calls",
    },
  ],
};

export const mockAllDepartmentsPipelineData: AllDepartmentsPipelineModel = {
  totalStatistics: {
    leadsTotal: 150,
    leadsToday: 25,
    predictedToDocs: 12,
    docsToday: 8,
    gapDocsOut: 10,
    gapReadyToGo: 5,
    gapPayout: 3,
    gapTotal: 18,
    predictedToPay: 8,
    paidToday: 4,
  },
  statisticsGroups: [
    {
      departmentGroupName: "Near Prime",
      departmentGroupSortOrder: 1,
      statistics: [
        {
          departmentId: "NP5",
          departmentName: "Near Prime 5",
          leadsTotal: 30,
          leadsToday: 5,
          predictedToDocs: 3,
          docsToday: 2,
          gapDocsOut: 2,
          gapReadyToGo: 1,
          gapPayout: 1,
          gapTotal: 4,
          predictedToPay: 2,
          paidToday: 1,
        },
        {
          departmentId: "NP6",
          departmentName: "Near Prime 6",
          leadsTotal: 25,
          leadsToday: 4,
          predictedToDocs: 2,
          docsToday: 1,
          gapDocsOut: 2,
          gapReadyToGo: 1,
          gapPayout: 0,
          gapTotal: 3,
          predictedToPay: 1,
          paidToday: 1,
        },
        {
          departmentId: "NP7",
          departmentName: "Near Prime 7",
          leadsTotal: 20,
          leadsToday: 3,
          predictedToDocs: 2,
          docsToday: 1,
          gapDocsOut: 1,
          gapReadyToGo: 1,
          gapPayout: 0,
          gapTotal: 2,
          predictedToPay: 1,
          paidToday: 0,
        },
        {
          departmentId: "NP8",
          departmentName: "Near Prime 8",
          leadsTotal: 22,
          leadsToday: 4,
          predictedToDocs: 2,
          docsToday: 1,
          gapDocsOut: 1,
          gapReadyToGo: 1,
          gapPayout: 0,
          gapTotal: 2,
          predictedToPay: 1,
          paidToday: 1,
        },
        {
          departmentId: "NP9",
          departmentName: "Near Prime 9",
          leadsTotal: 18,
          leadsToday: 3,
          predictedToDocs: 1,
          docsToday: 1,
          gapDocsOut: 1,
          gapReadyToGo: 0,
          gapPayout: 0,
          gapTotal: 1,
          predictedToPay: 0,
          paidToday: 0,
        },
        {
          departmentId: "NP10",
          departmentName: "Near Prime 10",
          leadsTotal: 20,
          leadsToday: 3,
          predictedToDocs: 1,
          docsToday: 0,
          gapDocsOut: 0,
          gapReadyToGo: 1,
          gapPayout: 0,
          gapTotal: 1,
          predictedToPay: 0,
          paidToday: 0,
        },
        {
          departmentId: "NP11",
          departmentName: "Near Prime 11",
          leadsTotal: 25,
          leadsToday: 4,
          predictedToDocs: 2,
          docsToday: 1,
          gapDocsOut: 2,
          gapReadyToGo: 1,
          gapPayout: 0,
          gapTotal: 3,
          predictedToPay: 1,
          paidToday: 1,
        },
      ],
    },
  ],
};

export const mockDirectorOverviewData: DashboardPipelineModel = {
  docs: [
    { name: "Daniel O'Connor", predicted: 4, predictedActual: 3, actual: 4, totalReDoc: 0 },
    { name: "Daniel Fildes", predicted: 5, predictedActual: 4, actual: 7, totalReDoc: 0 },
    { name: "Daniel Sandham", predicted: 9, predictedActual: 7, actual: 8, totalReDoc: 0 },
  ],
  payouts: [
    { id: 1, name: "Daniel O'Connor", predicted: 2, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
    { id: 2, name: "Daniel Fildes", predicted: 1, predictedActual: 1, actual: 2, paidFromStartOfTheDay: 0 },
    { id: 3, name: "Daniel Sandham", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
  ],
  wiPs: [
    {
      id: 34,
      name: "Daniel O'Connor",
      docsOutBeforeOpening: 4,
      readyToGoBeforeOpening: 2,
      payoutBeforeOpening: 1,
      docsOutLive: 2,
      readyToGoLive: 5,
      payoutLive: 1,
    },
    {
      id: 35,
      name: "Daniel Fildes",
      docsOutBeforeOpening: 3,
      readyToGoBeforeOpening: 2,
      payoutBeforeOpening: 1,
      docsOutLive: 2,
      readyToGoLive: 3,
      payoutLive: 2,
    },
    {
      id: 36,
      name: "Daniel Sandham",
      docsOutBeforeOpening: 6,
      readyToGoBeforeOpening: 3,
      payoutBeforeOpening: 1,
      docsOutLive: 3,
      readyToGoLive: 4,
      payoutLive: 1,
    },
  ],
  allocations: [
    {
      name: "Daniel O'Connor",
      leadGen: 15,
      callbacks: 9,
      orders: 6,
      whatsapp: 3,
      other: 1,
      total: 34,
    },
    {
      name: "Daniel Fildes",
      leadGen: 15,
      callbacks: 8,
      orders: 6,
      whatsapp: 3,
      other: 2,
      total: 34,
    },
    {
      name: "Daniel Sandham",
      leadGen: 20,
      callbacks: 12,
      orders: 9,
      whatsapp: 4,
      other: 2,
      total: 47,
    },
  ],
  statistics: {
    docsPredicted: 18,
    docsActual: 19,
    paidPredicted: 3,
    paidActual: 2,
    gapDocsOut: 13,
    gapReadyToGo: 7,
    gapPayout: 3,
    gapTotal: 23,
    totalReDoc: 0,
  },
};

export const mockHoBDetailData: Record<string, DashboardPipelineModel> = {
  "Daniel O'Connor": {
    docs: [
      { name: "OSM Alpha", predicted: 2, predictedActual: 1, actual: 2, totalReDoc: 0 },
      { name: "OSM Beta", predicted: 2, predictedActual: 2, actual: 2, totalReDoc: 0 },
    ],
    payouts: [
      { id: 4, name: "OSM Alpha", predicted: 1, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
      { id: 5, name: "OSM Beta", predicted: 1, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
    ],
    wiPs: [
      {
        id: 37,
        name: "OSM Alpha",
        docsOutBeforeOpening: 2,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 0,
        docsOutLive: 1,
        readyToGoLive: 2,
        payoutLive: 1,
      },
      {
        id: 38,
        name: "OSM Beta",
        docsOutBeforeOpening: 2,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 1,
        docsOutLive: 1,
        readyToGoLive: 3,
        payoutLive: 0,
      },
    ],
    allocations: [
      {
        name: "OSM Alpha",
        leadGen: 9,
        callbacks: 5,
        orders: 3,
        whatsapp: 1,
        other: 0,
        total: 18,
      },
      {
        name: "OSM Beta",
        leadGen: 6,
        callbacks: 4,
        orders: 3,
        whatsapp: 2,
        other: 1,
        total: 16,
      },
    ],
    statistics: {
      docsPredicted: 4,
      docsActual: 4,
      paidPredicted: 2,
      paidActual: 0,
      gapDocsOut: 4,
      gapReadyToGo: 2,
      gapPayout: 1,
      gapTotal: 7,
      totalReDoc: 0,
    },
  },
  "Daniel Fildes": {
    docs: [{ name: "OSM Gamma", predicted: 5, predictedActual: 4, actual: 7, totalReDoc: 0 }],
    payouts: [{ id: 6, name: "OSM Gamma", predicted: 1, predictedActual: 1, actual: 2, paidFromStartOfTheDay: 0 }],
    wiPs: [
      {
        id: 39,
        name: "OSM Gamma",
        docsOutBeforeOpening: 3,
        readyToGoBeforeOpening: 2,
        payoutBeforeOpening: 1,
        docsOutLive: 2,
        readyToGoLive: 3,
        payoutLive: 2,
      },
    ],
    allocations: [
      {
        name: "OSM Gamma",
        leadGen: 15,
        callbacks: 8,
        orders: 6,
        whatsapp: 3,
        other: 2,
        total: 34,
      },
    ],
    statistics: {
      docsPredicted: 5,
      docsActual: 7,
      paidPredicted: 1,
      paidActual: 2,
      gapDocsOut: 3,
      gapReadyToGo: 2,
      gapPayout: 1,
      gapTotal: 6,
      totalReDoc: 0,
    },
  },
  "Daniel Sandham": {
    docs: [{ name: "OSM Delta", predicted: 9, predictedActual: 7, actual: 8, totalReDoc: 0 }],
    payouts: [{ id: 7, name: "OSM Delta", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 }],
    wiPs: [
      {
        id: 40,
        name: "OSM Delta",
        docsOutBeforeOpening: 6,
        readyToGoBeforeOpening: 3,
        payoutBeforeOpening: 1,
        docsOutLive: 3,
        readyToGoLive: 4,
        payoutLive: 1,
      },
    ],
    allocations: [
      {
        name: "OSM Delta",
        leadGen: 20,
        callbacks: 12,
        orders: 9,
        whatsapp: 4,
        other: 2,
        total: 47,
      },
    ],
    statistics: {
      docsPredicted: 9,
      docsActual: 8,
      paidPredicted: 0,
      paidActual: 0,
      gapDocsOut: 6,
      gapReadyToGo: 3,
      gapPayout: 1,
      gapTotal: 10,
      totalReDoc: 0,
    },
  },
};

export const mockOSMData: Record<string, DashboardPipelineModel> = {
  "OSM Alpha": {
    docs: [{ name: "Near Prime 6", predicted: 2, predictedActual: 1, actual: 2, totalReDoc: 0 }],
    payouts: [{ id: 8, name: "Near Prime 6", predicted: 1, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 }],
    wiPs: [
      {
        id: 41,
        name: "Near Prime 6",
        docsOutBeforeOpening: 2,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 0,
        docsOutLive: 1,
        readyToGoLive: 2,
        payoutLive: 1,
      },
    ],
    allocations: [
      {
        name: "Near Prime 6",
        leadGen: 5,
        callbacks: 3,
        orders: 2,
        whatsapp: 1,
        other: 0,
        total: 11,
      },
    ],
    statistics: {
      docsPredicted: 2,
      docsActual: 2,
      paidPredicted: 1,
      paidActual: 0,
      gapDocsOut: 2,
      gapReadyToGo: 1,
      gapPayout: 0,
      gapTotal: 3,
      totalReDoc: 0,
    },
  },
  "OSM Beta": {
    docs: [
      { name: "Near Prime 7", predicted: 1, predictedActual: 1, actual: 1, totalReDoc: 0 },
      { name: "Near Prime 8", predicted: 1, predictedActual: 1, actual: 1, totalReDoc: 0 },
    ],
    payouts: [
      { id: 9, name: "Near Prime 7", predicted: 1, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
      { id: 10, name: "Near Prime 8", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
    ],
    wiPs: [
      {
        id: 42,
        name: "Near Prime 7",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 0,
        payoutBeforeOpening: 0,
        docsOutLive: 0,
        readyToGoLive: 1,
        payoutLive: 0,
      },
      {
        id: 43,
        name: "Near Prime 8",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 1,
        docsOutLive: 2,
        readyToGoLive: 0,
        payoutLive: 0,
      },
    ],
    allocations: [
      {
        name: "Near Prime 7",
        leadGen: 4,
        callbacks: 2,
        orders: 1,
        whatsapp: 0,
        other: 1,
        total: 8,
      },
      {
        name: "Near Prime 8",
        leadGen: 6,
        callbacks: 4,
        orders: 3,
        whatsapp: 2,
        other: 0,
        total: 15,
      },
    ],
    statistics: {
      docsPredicted: 2,
      docsActual: 2,
      paidPredicted: 1,
      paidActual: 0,
      gapDocsOut: 2,
      gapReadyToGo: 1,
      gapPayout: 1,
      gapTotal: 4,
      totalReDoc: 0,
    },
  },
  "OSM Gamma": {
    docs: [
      { name: "Near Prime 9", predicted: 1, predictedActual: 1, actual: 2, totalReDoc: 0 },
      { name: "Near Prime 10", predicted: 1, predictedActual: 1, actual: 1, totalReDoc: 0 },
      { name: "Near Prime 5", predicted: 3, predictedActual: 2, actual: 4, totalReDoc: 0 },
    ],
    payouts: [
      { id: 11, name: "Near Prime 9", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
      { id: 12, name: "Near Prime 10", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
      { id: 13, name: "Near Prime 5", predicted: 1, predictedActual: 1, actual: 2, paidFromStartOfTheDay: 0 },
    ],
    wiPs: [
      {
        id: 44,
        name: "Near Prime 9",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 0,
        payoutBeforeOpening: 0,
        docsOutLive: 0,
        readyToGoLive: 1,
        payoutLive: 0,
      },
      {
        id: 45,
        name: "Near Prime 10",
        docsOutBeforeOpening: 0,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 0,
        docsOutLive: 1,
        readyToGoLive: 0,
        payoutLive: 1,
      },
      {
        id: 46,
        name: "Near Prime 5",
        docsOutBeforeOpening: 2,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 1,
        docsOutLive: 1,
        readyToGoLive: 2,
        payoutLive: 1,
      },
    ],
    allocations: [
      {
        name: "Near Prime 9",
        leadGen: 3,
        callbacks: 2,
        orders: 1,
        whatsapp: 1,
        other: 0,
        total: 7,
      },
      {
        name: "Near Prime 10",
        leadGen: 4,
        callbacks: 1,
        orders: 2,
        whatsapp: 0,
        other: 1,
        total: 8,
      },
      {
        name: "Near Prime 5",
        leadGen: 8,
        callbacks: 5,
        orders: 3,
        whatsapp: 2,
        other: 1,
        total: 19,
      },
    ],
    statistics: {
      docsPredicted: 5,
      docsActual: 7,
      paidPredicted: 1,
      paidActual: 2,
      gapDocsOut: 3,
      gapReadyToGo: 2,
      gapPayout: 1,
      gapTotal: 6,
      totalReDoc: 0,
    },
  },
  "OSM Delta": {
    docs: [{ name: "Near Prime 11", predicted: 3, predictedActual: 2, actual: 3, totalReDoc: 0 }],
    payouts: [{ id: 14, name: "Near Prime 11", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 }],
    wiPs: [
      {
        id: 47,
        name: "Near Prime 11",
        docsOutBeforeOpening: 2,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 1,
        docsOutLive: 1,
        readyToGoLive: 2,
        payoutLive: 0,
      },
    ],
    allocations: [
      {
        name: "Near Prime 11",
        leadGen: 7,
        callbacks: 4,
        orders: 3,
        whatsapp: 2,
        other: 1,
        total: 17,
      },
    ],
    statistics: {
      docsPredicted: 3,
      docsActual: 3,
      paidPredicted: 0,
      paidActual: 0,
      gapDocsOut: 2,
      gapReadyToGo: 1,
      gapPayout: 1,
      gapTotal: 4,
      totalReDoc: 0,
    },
  },
};

export const mockSalesHierarchy: SalesHierarchyModel[] = [
  {
    departmentId: "NP6",
    departmentName: "Near Prime 6",
    osmId: 101,
    osmName: "OSM Alpha",
    hosId: 1,
    hosName: "Daniel O'Connor",
  },
  {
    departmentId: "NP7",
    departmentName: "Near Prime 7",
    osmId: 102,
    osmName: "OSM Beta",
    hosId: 1,
    hosName: "Daniel O'Connor",
  },
  {
    departmentId: "NP8",
    departmentName: "Near Prime 8",
    osmId: 102,
    osmName: "OSM Beta",
    hosId: 1,
    hosName: "Daniel O'Connor",
  },
  {
    departmentId: "NP9",
    departmentName: "Near Prime 9",
    osmId: 103,
    osmName: "OSM Gamma",
    hosId: 2,
    hosName: "Daniel Fildes",
  },
  {
    departmentId: "NP10",
    departmentName: "Near Prime 10",
    osmId: 103,
    osmName: "OSM Gamma",
    hosId: 2,
    hosName: "Daniel Fildes",
  },
  {
    departmentId: "NP5",
    departmentName: "Near Prime 5",
    osmId: 103,
    osmName: "OSM Gamma",
    hosId: 2,
    hosName: "Daniel Fildes",
  },
  {
    departmentId: "NP11",
    departmentName: "Near Prime 11",
    osmId: 104,
    osmName: "OSM Delta",
    hosId: 3,
    hosName: "Daniel Sandham",
  },
];

export const mockTeamOptions = [
  { value: "NP5", label: "Near Prime 5" },
  { value: "NP6", label: "Near Prime 6" },
  { value: "NP7", label: "Near Prime 7" },
  { value: "NP8", label: "Near Prime 8" },
  { value: "NP9", label: "Near Prime 9" },
  { value: "NP10", label: "Near Prime 10" },
  { value: "NP11", label: "Near Prime 11" },
];

export const mockAgentOptions = [
  { value: 100, label: "Agent 1" },
  { value: 101, label: "Agent 2" },
  { value: 102, label: "Agent 3" },
  { value: 104, label: "Agent 4" },
  { value: 105, label: "Agent 5" },
  { value: 106, label: "Agent 6" },
  { value: 103, label: "Agent 7" },
  { value: 107, label: "Agent 8" },
  { value: 108, label: "Agent 9" },
  { value: 109, label: "Agent 10" },
  { value: 110, label: "Agent 11" },
  { value: 111, label: "Agent 12" },
  { value: 112, label: "Agent 13" },
  { value: 113, label: "Agent 14" },
  { value: 114, label: "Agent 15" },
  { value: 115, label: "Agent 16" },
  { value: 116, label: "Agent 17" },
  { value: 117, label: "Agent 18" },
  { value: 118, label: "Agent 19" },
];

export const mockWorkers = [
  {
    userGuid: "mock-user-guid-1",
    userId: 100,
    departmentId: "NP11",
    department: "Near Prime 11",
    name: "Agent 1",
    email: "demo@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 10,
    grade: 5,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-2",
    userId: 101,
    departmentId: "NP11",
    department: "Near Prime 11",
    name: "Agent 2",
    email: "agent2@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 8,
    grade: 4,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-3",
    userId: 102,
    departmentId: "NP11",
    department: "Near Prime 11",
    name: "Agent 3",
    email: "agent3@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 12,
    grade: 6,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-4",
    userId: 103,
    departmentId: "NP5",
    department: "Near Prime 5",
    name: "Agent 7",
    email: "sp-agent@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 10,
    grade: 5,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-5",
    userId: 104,
    departmentId: "NP11",
    department: "Near Prime 11",
    name: "Agent 4",
    email: "agent4@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 9,
    grade: 5,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-6",
    userId: 105,
    departmentId: "NP11",
    department: "Near Prime 11",
    name: "Agent 5",
    email: "agent5@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 11,
    grade: 6,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-7",
    userId: 106,
    departmentId: "NP5",
    department: "Near Prime 5",
    name: "Agent 6",
    email: "agent6@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 10,
    grade: 5,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-8",
    userId: 107,
    departmentId: "NP6",
    department: "Near Prime 6",
    name: "Agent 8",
    email: "np6-agent1@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 10,
    grade: 5,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-9",
    userId: 108,
    departmentId: "NP6",
    department: "Near Prime 6",
    name: "Agent 9",
    email: "np6-agent2@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 9,
    grade: 5,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-10",
    userId: 109,
    departmentId: "NP7",
    department: "Near Prime 7",
    name: "Agent 10",
    email: "np7-agent1@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 8,
    grade: 4,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-11",
    userId: 110,
    departmentId: "NP8",
    department: "Near Prime 8",
    name: "Agent 11",
    email: "np8-agent1@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 11,
    grade: 6,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-12",
    userId: 111,
    departmentId: "NP8",
    department: "Near Prime 8",
    name: "Agent 12",
    email: "np8-agent2@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 10,
    grade: 5,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-13",
    userId: 112,
    departmentId: "NP9",
    department: "Near Prime 9",
    name: "Agent 13",
    email: "np9-agent1@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 9,
    grade: 5,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-14",
    userId: 113,
    departmentId: "NP10",
    department: "Near Prime 10",
    name: "Agent 14",
    email: "np10-agent1@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 10,
    grade: 5,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-15",
    userId: 114,
    departmentId: "NP10",
    department: "Near Prime 10",
    name: "Agent 15",
    email: "np10-agent2@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 8,
    grade: 4,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-16",
    userId: 115,
    departmentId: "NP5",
    department: "Near Prime 5",
    name: "Agent 16",
    email: "dev-agent1@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 12,
    grade: 6,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-17",
    userId: 116,
    departmentId: "NP5",
    department: "Near Prime 5",
    name: "Agent 17",
    email: "dev-agent2@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 11,
    grade: 6,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-18",
    userId: 117,
    departmentId: "NP5",
    department: "Near Prime 5",
    name: "Agent 18",
    email: "dev-agent3@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 10,
    grade: 5,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
  {
    userGuid: "mock-user-guid-19",
    userId: 118,
    departmentId: "NP5",
    department: "Near Prime 5",
    name: "Agent 19",
    email: "dev-agent4@example.com",
    password: null,
    allowRemoteAccess: true,
    creditCheckVisibilityId: 1,
    profileVisibilityTypeId: 1,
    profileImageUrl: null,
    isFinanceExecutive: false,
    financeExecutive: null,
    active: true,
    isDeleted: false,
    iid: null,
    duplicateNameNumber: null,
    isFlexUser: true,
    extension: null,
    isReceivingLeads: true,
    target: 9,
    grade: 5,
    chatCapacity: 3,
    voiceCapacity: 1,
  },
];

export const mockDepartments = [
  {
    departmentId: "NP5",
    department: "Near Prime 5",
    description: "Near Prime Team 5",
    groupPhoneNumber: "+441234567890",
  },
  {
    departmentId: "NP6",
    department: "Near Prime 6",
    description: "Near Prime Team 6",
    groupPhoneNumber: "+441234567895",
  },
  {
    departmentId: "NP7",
    department: "Near Prime 7",
    description: "Near Prime Team 7",
    groupPhoneNumber: "+441234567896",
  },
  {
    departmentId: "NP8",
    department: "Near Prime 8",
    description: "Near Prime Team 8",
    groupPhoneNumber: "+441234567897",
  },
  {
    departmentId: "NP9",
    department: "Near Prime 9",
    description: "Near Prime Team 9",
    groupPhoneNumber: "+441234567898",
  },
  {
    departmentId: "NP10",
    department: "Near Prime 10",
    description: "Near Prime Team 10",
    groupPhoneNumber: "+441234567899",
  },
  {
    departmentId: "NP11",
    department: "Near Prime 11",
    description: "Near Prime Team 11",
    groupPhoneNumber: "+441234567892",
  },
];

export const DEFAULT_BUSINESS_OPTIONS = [
  { value: "Whole Business", label: "Whole Business" },
  { value: "Consumer Direct", label: "Consumer Direct" },
  { value: "Dealer Direct", label: "Dealer Direct" },
];

export const mockTeamData: Record<string, DashboardPipelineModel> = {
  NP11: {
    docs: [
      { name: "Agent 1", predicted: 2, predictedActual: 1, actual: 2, totalReDoc: 0 },
      { name: "Agent 2", predicted: 1, predictedActual: 1, actual: 1, totalReDoc: 0 },
      { name: "Agent 3", predicted: 1, predictedActual: 0, actual: 1, totalReDoc: 0 },
      { name: "Agent 4", predicted: 1, predictedActual: 1, actual: 1, totalReDoc: 0 },
      { name: "Agent 5", predicted: 2, predictedActual: 1, actual: 2, totalReDoc: 0 },
    ],
    payouts: [
      { id: 15, name: "Agent 1", predicted: 1, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
      { id: 16, name: "Agent 2", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
      { id: 17, name: "Agent 3", predicted: 1, predictedActual: 1, actual: 1, paidFromStartOfTheDay: 0 },
      { id: 18, name: "Agent 4", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
      { id: 19, name: "Agent 5", predicted: 1, predictedActual: 1, actual: 1, paidFromStartOfTheDay: 0 },
    ],
    wiPs: [
      {
        id: 48,
        name: "Agent 1",
        docsOutBeforeOpening: 2,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 0,
        docsOutLive: 1,
        readyToGoLive: 2,
        payoutLive: 1,
      },
      {
        id: 49,
        name: "Agent 2",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 0,
        payoutBeforeOpening: 0,
        docsOutLive: 0,
        readyToGoLive: 1,
        payoutLive: 0,
      },
      {
        id: 50,
        name: "Agent 3",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 1,
        docsOutLive: 2,
        readyToGoLive: 0,
        payoutLive: 0,
      },
      {
        id: 51,
        name: "Agent 4",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 0,
        payoutBeforeOpening: 0,
        docsOutLive: 0,
        readyToGoLive: 1,
        payoutLive: 0,
      },
      {
        id: 52,
        name: "Agent 5",
        docsOutBeforeOpening: 2,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 0,
        docsOutLive: 1,
        readyToGoLive: 2,
        payoutLive: 0,
      },
    ],
    allocations: [
      {
        name: "Agent 1",
        leadGen: 5,
        callbacks: 3,
        orders: 2,
        whatsapp: 1,
        other: 0,
        total: 11,
      },
      {
        name: "Agent 2",
        leadGen: 4,
        callbacks: 2,
        orders: 1,
        whatsapp: 0,
        other: 1,
        total: 8,
      },
      {
        name: "Agent 3",
        leadGen: 6,
        callbacks: 4,
        orders: 3,
        whatsapp: 2,
        other: 0,
        total: 15,
      },
      {
        name: "Agent 4",
        leadGen: 3,
        callbacks: 2,
        orders: 1,
        whatsapp: 1,
        other: 0,
        total: 7,
      },
      {
        name: "Agent 5",
        leadGen: 7,
        callbacks: 4,
        orders: 3,
        whatsapp: 2,
        other: 1,
        total: 17,
      },
    ],
    statistics: {
      docsPredicted: 7,
      docsActual: 7,
      paidPredicted: 3,
      paidActual: 2,
      gapDocsOut: 7,
      gapReadyToGo: 3,
      gapPayout: 1,
      gapTotal: 11,
      totalReDoc: 0,
    },
  },
  NP6: {
    docs: [
      { name: "Agent 8", predicted: 1, predictedActual: 1, actual: 1, totalReDoc: 0 },
      { name: "Agent 9", predicted: 1, predictedActual: 0, actual: 1, totalReDoc: 0 },
    ],
    payouts: [
      { id: 20, name: "Agent 8", predicted: 1, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
      { id: 21, name: "Agent 9", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
    ],
    wiPs: [
      {
        id: 53,
        name: "Agent 8",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 0,
        docsOutLive: 1,
        readyToGoLive: 1,
        payoutLive: 1,
      },
      {
        id: 54,
        name: "Agent 9",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 0,
        payoutBeforeOpening: 0,
        docsOutLive: 0,
        readyToGoLive: 1,
        payoutLive: 0,
      },
    ],
    allocations: [
      {
        name: "Agent 8",
        leadGen: 3,
        callbacks: 2,
        orders: 1,
        whatsapp: 1,
        other: 0,
        total: 7,
      },
      {
        name: "Agent 9",
        leadGen: 2,
        callbacks: 1,
        orders: 1,
        whatsapp: 0,
        other: 0,
        total: 4,
      },
    ],
    statistics: {
      docsPredicted: 2,
      docsActual: 2,
      paidPredicted: 1,
      paidActual: 0,
      gapDocsOut: 2,
      gapReadyToGo: 1,
      gapPayout: 0,
      gapTotal: 3,
      totalReDoc: 0,
    },
  },
  NP7: {
    docs: [{ name: "Agent 10", predicted: 1, predictedActual: 1, actual: 1, totalReDoc: 0 }],
    payouts: [{ id: 22, name: "Agent 10", predicted: 1, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 }],
    wiPs: [
      {
        id: 55,
        name: "Agent 10",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 0,
        payoutBeforeOpening: 0,
        docsOutLive: 0,
        readyToGoLive: 1,
        payoutLive: 0,
      },
    ],
    allocations: [
      {
        name: "Agent 10",
        leadGen: 4,
        callbacks: 2,
        orders: 1,
        whatsapp: 0,
        other: 1,
        total: 8,
      },
    ],
    statistics: {
      docsPredicted: 1,
      docsActual: 1,
      paidPredicted: 1,
      paidActual: 0,
      gapDocsOut: 1,
      gapReadyToGo: 0,
      gapPayout: 0,
      gapTotal: 1,
      totalReDoc: 0,
    },
  },
  NP8: {
    docs: [
      { name: "Agent 11", predicted: 1, predictedActual: 1, actual: 1, totalReDoc: 0 },
      { name: "Agent 12", predicted: 0, predictedActual: 0, actual: 0, totalReDoc: 0 },
    ],
    payouts: [
      { id: 23, name: "Agent 11", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
      { id: 24, name: "Agent 12", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
    ],
    wiPs: [
      {
        id: 56,
        name: "Agent 11",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 1,
        docsOutLive: 2,
        readyToGoLive: 0,
        payoutLive: 0,
      },
      {
        id: 57,
        name: "Agent 12",
        docsOutBeforeOpening: 0,
        readyToGoBeforeOpening: 0,
        payoutBeforeOpening: 0,
        docsOutLive: 0,
        readyToGoLive: 0,
        payoutLive: 0,
      },
    ],
    allocations: [
      {
        name: "Agent 11",
        leadGen: 4,
        callbacks: 3,
        orders: 2,
        whatsapp: 1,
        other: 0,
        total: 10,
      },
      {
        name: "Agent 12",
        leadGen: 2,
        callbacks: 1,
        orders: 1,
        whatsapp: 1,
        other: 0,
        total: 5,
      },
    ],
    statistics: {
      docsPredicted: 1,
      docsActual: 1,
      paidPredicted: 0,
      paidActual: 0,
      gapDocsOut: 1,
      gapReadyToGo: 1,
      gapPayout: 1,
      gapTotal: 3,
      totalReDoc: 0,
    },
  },
  NP9: {
    docs: [{ name: "Agent 13", predicted: 1, predictedActual: 1, actual: 2, totalReDoc: 0 }],
    payouts: [{ id: 25, name: "Agent 13", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 }],
    wiPs: [
      {
        id: 58,
        name: "Agent 13",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 0,
        payoutBeforeOpening: 0,
        docsOutLive: 0,
        readyToGoLive: 1,
        payoutLive: 0,
      },
    ],
    allocations: [
      {
        name: "Agent 13",
        leadGen: 3,
        callbacks: 2,
        orders: 1,
        whatsapp: 1,
        other: 0,
        total: 7,
      },
    ],
    statistics: {
      docsPredicted: 1,
      docsActual: 2,
      paidPredicted: 0,
      paidActual: 0,
      gapDocsOut: 1,
      gapReadyToGo: 0,
      gapPayout: 0,
      gapTotal: 1,
      totalReDoc: 0,
    },
  },
  NP10: {
    docs: [
      { name: "Agent 14", predicted: 1, predictedActual: 1, actual: 1, totalReDoc: 0 },
      { name: "Agent 15", predicted: 0, predictedActual: 0, actual: 0, totalReDoc: 0 },
    ],
    payouts: [
      { id: 26, name: "Agent 14", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
      { id: 27, name: "Agent 15", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
    ],
    wiPs: [
      {
        id: 59,
        name: "Agent 14",
        docsOutBeforeOpening: 0,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 0,
        docsOutLive: 1,
        readyToGoLive: 0,
        payoutLive: 1,
      },
      {
        id: 60,
        name: "Agent 15",
        docsOutBeforeOpening: 0,
        readyToGoBeforeOpening: 0,
        payoutBeforeOpening: 0,
        docsOutLive: 0,
        readyToGoLive: 0,
        payoutLive: 0,
      },
    ],
    allocations: [
      {
        name: "Agent 14",
        leadGen: 3,
        callbacks: 1,
        orders: 1,
        whatsapp: 0,
        other: 1,
        total: 6,
      },
      {
        name: "Agent 15",
        leadGen: 1,
        callbacks: 0,
        orders: 1,
        whatsapp: 0,
        other: 0,
        total: 2,
      },
    ],
    statistics: {
      docsPredicted: 1,
      docsActual: 1,
      paidPredicted: 0,
      paidActual: 0,
      gapDocsOut: 0,
      gapReadyToGo: 1,
      gapPayout: 0,
      gapTotal: 1,
      totalReDoc: 0,
    },
  },
  NP5: {
    docs: [
      { name: "Agent 6", predicted: 1, predictedActual: 1, actual: 1, totalReDoc: 0 },
      { name: "Agent 7", predicted: 1, predictedActual: 0, actual: 1, totalReDoc: 0 },
      { name: "Agent 16", predicted: 3, predictedActual: 2, actual: 3, totalReDoc: 0 },
      { name: "Agent 17", predicted: 2, predictedActual: 2, actual: 2, totalReDoc: 0 },
      { name: "Agent 18", predicted: 1, predictedActual: 1, actual: 2, totalReDoc: 0 },
      { name: "Agent 19", predicted: 2, predictedActual: 1, actual: 1, totalReDoc: 0 },
    ],
    payouts: [
      { id: 28, name: "Agent 6", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
      { id: 29, name: "Agent 7", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
      { id: 30, name: "Agent 16", predicted: 1, predictedActual: 1, actual: 2, paidFromStartOfTheDay: 0 },
      { id: 31, name: "Agent 17", predicted: 1, predictedActual: 0, actual: 1, paidFromStartOfTheDay: 0 },
      { id: 32, name: "Agent 18", predicted: 0, predictedActual: 0, actual: 0, paidFromStartOfTheDay: 0 },
      { id: 33, name: "Agent 19", predicted: 1, predictedActual: 1, actual: 1, paidFromStartOfTheDay: 0 },
    ],
    wiPs: [
      {
        id: 61,
        name: "Agent 6",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 0,
        payoutBeforeOpening: 0,
        docsOutLive: 0,
        readyToGoLive: 1,
        payoutLive: 0,
      },
      {
        id: 62,
        name: "Agent 7",
        docsOutBeforeOpening: 0,
        readyToGoBeforeOpening: 0,
        payoutBeforeOpening: 0,
        docsOutLive: 0,
        readyToGoLive: 0,
        payoutLive: 0,
      },
      {
        id: 63,
        name: "Agent 16",
        docsOutBeforeOpening: 2,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 1,
        docsOutLive: 1,
        readyToGoLive: 2,
        payoutLive: 1,
      },
      {
        id: 64,
        name: "Agent 17",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 0,
        docsOutLive: 2,
        readyToGoLive: 1,
        payoutLive: 0,
      },
      {
        id: 65,
        name: "Agent 18",
        docsOutBeforeOpening: 1,
        readyToGoBeforeOpening: 0,
        payoutBeforeOpening: 0,
        docsOutLive: 0,
        readyToGoLive: 1,
        payoutLive: 0,
      },
      {
        id: 66,
        name: "Agent 19",
        docsOutBeforeOpening: 2,
        readyToGoBeforeOpening: 1,
        payoutBeforeOpening: 1,
        docsOutLive: 1,
        readyToGoLive: 1,
        payoutLive: 1,
      },
    ],
    allocations: [
      {
        name: "Agent 6",
        leadGen: 2,
        callbacks: 1,
        orders: 1,
        whatsapp: 0,
        other: 0,
        total: 4,
      },
      {
        name: "Agent 7",
        leadGen: 2,
        callbacks: 1,
        orders: 0,
        whatsapp: 0,
        other: 0,
        total: 3,
      },
      {
        name: "Agent 16",
        leadGen: 6,
        callbacks: 4,
        orders: 2,
        whatsapp: 2,
        other: 1,
        total: 15,
      },
      {
        name: "Agent 17",
        leadGen: 5,
        callbacks: 3,
        orders: 2,
        whatsapp: 1,
        other: 0,
        total: 11,
      },
      {
        name: "Agent 18",
        leadGen: 4,
        callbacks: 2,
        orders: 1,
        whatsapp: 1,
        other: 1,
        total: 9,
      },
      {
        name: "Agent 19",
        leadGen: 7,
        callbacks: 4,
        orders: 3,
        whatsapp: 2,
        other: 0,
        total: 16,
      },
    ],
    statistics: {
      docsPredicted: 10,
      docsActual: 10,
      paidPredicted: 3,
      paidActual: 4,
      gapDocsOut: 7,
      gapReadyToGo: 3,
      gapPayout: 2,
      gapTotal: 12,
      totalReDoc: 0,
    },
  },
};

export const mockShiftCaps: AllocationSkillResponse[] = [
  {
    userId: 100,
    receivingLeads: true,
    shiftStart: "2026-02-13T09:00:00+00:00",
    shiftEnd: "2026-02-13T18:00:00+00:00",
    allocationSkills: { "19": 6, "20": 12, "21": 5, "42": 5, "43": 5, "49": 5, "53": 5 },
  },
  {
    userId: 101,
    receivingLeads: true,
    shiftStart: "2026-02-13T08:00:00+00:00",
    shiftEnd: "2026-02-13T17:00:00+00:00",
    allocationSkills: { "19": 8, "20": 10, "21": 3, "42": 4, "43": 6, "49": 2, "53": 3 },
  },
  {
    userId: 102,
    receivingLeads: true,
    shiftStart: "2026-02-13T10:00:00+00:00",
    shiftEnd: "2026-02-13T19:00:00+00:00",
    allocationSkills: { "19": 4, "20": 15, "21": 7, "42": 3, "43": 2, "49": 8, "53": 4 },
  },
  {
    userId: 103,
    receivingLeads: true,
    shiftStart: "2026-02-13T09:00:00+00:00",
    shiftEnd: "2026-02-13T18:00:00+00:00",
    allocationSkills: { "19": 10, "20": 8, "21": 4, "42": 6, "43": 3, "49": 4, "53": 6 },
  },
  {
    userId: 104,
    receivingLeads: false,
    shiftStart: "2026-02-13T07:00:00+00:00",
    shiftEnd: "2026-02-13T16:00:00+00:00",
    allocationSkills: { "19": 5, "20": 20, "21": 10, "42": 8, "43": 4, "49": 6, "53": 5 },
  },
  {
    userId: 105,
    receivingLeads: true,
    shiftStart: "2026-02-13T11:00:00+00:00",
    shiftEnd: "2026-02-13T20:00:00+00:00",
    allocationSkills: { "19": 7, "20": 6, "21": 8, "42": 5, "43": 7, "49": 3, "53": 7 },
  },
  {
    userId: 106,
    receivingLeads: true,
    shiftStart: "2026-02-13T09:00:00+00:00",
    shiftEnd: "2026-02-13T18:00:00+00:00",
    allocationSkills: { "19": 9, "20": 11, "21": 6, "42": 4, "43": 5, "49": 5, "53": 5 },
  },
  {
    userId: 107,
    receivingLeads: true,
    shiftStart: "2026-02-13T08:30:00+00:00",
    shiftEnd: "2026-02-13T17:30:00+00:00",
    allocationSkills: { "19": 3, "20": 14, "21": 9, "42": 7, "43": 2, "49": 7, "53": 3 },
  },
  {
    userId: 108,
    receivingLeads: false,
    shiftStart: "2026-02-13T09:00:00+00:00",
    shiftEnd: "2026-02-13T17:00:00+00:00",
    allocationSkills: { "19": 5, "20": 8, "21": 4, "42": 3, "43": 3, "49": 4, "53": 2 },
  },
  {
    userId: 109,
    receivingLeads: true,
    shiftStart: "2026-02-13T08:00:00+00:00",
    shiftEnd: "2026-02-13T16:30:00+00:00",
    allocationSkills: { "19": 6, "20": 10, "21": 5, "42": 5, "43": 4, "49": 6, "53": 4 },
  },
  {
    userId: 110,
    receivingLeads: true,
    shiftStart: "2026-02-13T09:30:00+00:00",
    shiftEnd: "2026-02-13T18:30:00+00:00",
    allocationSkills: { "19": 8, "20": 12, "21": 6, "42": 4, "43": 5, "49": 3, "53": 6 },
  },
  {
    userId: 111,
    receivingLeads: true,
    shiftStart: "2026-02-13T10:00:00+00:00",
    shiftEnd: "2026-02-13T19:00:00+00:00",
    allocationSkills: { "19": 4, "20": 9, "21": 7, "42": 6, "43": 3, "49": 5, "53": 3 },
  },
  {
    userId: 112,
    receivingLeads: true,
    shiftStart: "2026-02-13T08:00:00+00:00",
    shiftEnd: "2026-02-13T17:00:00+00:00",
    allocationSkills: { "19": 7, "20": 7, "21": 3, "42": 5, "43": 6, "49": 4, "53": 5 },
  },
  {
    userId: 113,
    receivingLeads: false,
    shiftStart: "2026-02-13T09:00:00+00:00",
    shiftEnd: "2026-02-13T18:00:00+00:00",
    allocationSkills: { "19": 5, "20": 13, "21": 8, "42": 3, "43": 4, "49": 7, "53": 4 },
  },
  {
    userId: 114,
    receivingLeads: true,
    shiftStart: "2026-02-13T07:30:00+00:00",
    shiftEnd: "2026-02-13T16:30:00+00:00",
    allocationSkills: { "19": 6, "20": 11, "21": 5, "42": 7, "43": 2, "49": 3, "53": 6 },
  },
  {
    userId: 115,
    receivingLeads: true,
    shiftStart: "2026-02-13T09:00:00+00:00",
    shiftEnd: "2026-02-13T18:00:00+00:00",
    allocationSkills: { "19": 10, "20": 15, "21": 8, "42": 6, "43": 5, "49": 6, "53": 7 },
  },
  {
    userId: 116,
    receivingLeads: true,
    shiftStart: "2026-02-13T08:00:00+00:00",
    shiftEnd: "2026-02-13T17:00:00+00:00",
    allocationSkills: { "19": 8, "20": 10, "21": 6, "42": 5, "43": 4, "49": 5, "53": 4 },
  },
  {
    userId: 117,
    receivingLeads: false,
    shiftStart: "2026-02-13T10:00:00+00:00",
    shiftEnd: "2026-02-13T19:00:00+00:00",
    allocationSkills: { "19": 4, "20": 8, "21": 4, "42": 3, "43": 3, "49": 2, "53": 3 },
  },
  {
    userId: 118,
    receivingLeads: true,
    shiftStart: "2026-02-13T09:00:00+00:00",
    shiftEnd: "2026-02-13T18:00:00+00:00",
    allocationSkills: { "19": 7, "20": 12, "21": 5, "42": 4, "43": 5, "49": 4, "53": 5 },
  },
];

export const mockAvailableSkills: AvailableSkill[] = [
  { allocationSkillId: 1, allocationSkillTypeId: 1, name: "247 Money", value: "57" },
  { allocationSkillId: 19, allocationSkillTypeId: 6, name: "Digital", value: "8,9" },
  { allocationSkillId: 20, allocationSkillTypeId: 6, name: "Callback", value: "2" },
  { allocationSkillId: 21, allocationSkillTypeId: 6, name: "Lead Gen", value: "3" },
  { allocationSkillId: 42, allocationSkillTypeId: 6, name: "Customer Order", value: "10" },
  { allocationSkillId: 43, allocationSkillTypeId: 6, name: "Refer a Friend", value: "11" },
  { allocationSkillId: 49, allocationSkillTypeId: 6, name: "Customer Order VDP", value: "14" },
  { allocationSkillId: 53, allocationSkillTypeId: 6, name: "Powered By Allocations", value: "16" },
];

export const mockUserSkillAssignments: UserSkillAssignment[] = [
  {
    intranetUserId: 100,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 100,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 5,
    cap: null,
  },
  {
    intranetUserId: 100,
    allocationSkillId: 21,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 2,
    cap: null,
  },
  {
    intranetUserId: 101,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 4,
    cap: null,
  },
  {
    intranetUserId: 101,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 6,
    cap: null,
  },
  {
    intranetUserId: 101,
    allocationSkillId: 42,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 1,
    cap: null,
  },
  {
    intranetUserId: 102,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 8,
    cap: null,
  },
  {
    intranetUserId: 102,
    allocationSkillId: 21,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 102,
    allocationSkillId: 49,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 2,
    cap: null,
  },
  {
    intranetUserId: 103,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 5,
    cap: null,
  },
  {
    intranetUserId: 103,
    allocationSkillId: 42,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 103,
    allocationSkillId: 53,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 2,
    cap: null,
  },
  {
    intranetUserId: 104,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 10,
    cap: null,
  },
  {
    intranetUserId: 104,
    allocationSkillId: 21,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 5,
    cap: null,
  },
  {
    intranetUserId: 104,
    allocationSkillId: 43,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 2,
    cap: null,
  },
  {
    intranetUserId: 105,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 105,
    allocationSkillId: 21,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 4,
    cap: null,
  },
  {
    intranetUserId: 105,
    allocationSkillId: 43,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 106,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 4,
    cap: null,
  },
  {
    intranetUserId: 106,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 6,
    cap: null,
  },
  {
    intranetUserId: 107,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 7,
    cap: null,
  },
  {
    intranetUserId: 107,
    allocationSkillId: 21,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 4,
    cap: null,
  },
  {
    intranetUserId: 107,
    allocationSkillId: 49,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 108,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 2,
    cap: null,
  },
  {
    intranetUserId: 108,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 4,
    cap: null,
  },
  {
    intranetUserId: 109,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 109,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 5,
    cap: null,
  },
  {
    intranetUserId: 109,
    allocationSkillId: 49,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 110,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 4,
    cap: null,
  },
  {
    intranetUserId: 110,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 6,
    cap: null,
  },
  {
    intranetUserId: 110,
    allocationSkillId: 53,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 111,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 4,
    cap: null,
  },
  {
    intranetUserId: 111,
    allocationSkillId: 21,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 112,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 112,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 112,
    allocationSkillId: 43,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 2,
    cap: null,
  },
  {
    intranetUserId: 113,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 6,
    cap: null,
  },
  {
    intranetUserId: 113,
    allocationSkillId: 21,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 4,
    cap: null,
  },
  {
    intranetUserId: 113,
    allocationSkillId: 49,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 114,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 114,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 5,
    cap: null,
  },
  {
    intranetUserId: 114,
    allocationSkillId: 42,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 115,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 5,
    cap: null,
  },
  {
    intranetUserId: 115,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 8,
    cap: null,
  },
  {
    intranetUserId: 115,
    allocationSkillId: 21,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 4,
    cap: null,
  },
  {
    intranetUserId: 115,
    allocationSkillId: 53,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 116,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 4,
    cap: null,
  },
  {
    intranetUserId: 116,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 5,
    cap: null,
  },
  {
    intranetUserId: 116,
    allocationSkillId: 42,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 2,
    cap: null,
  },
  {
    intranetUserId: 117,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 2,
    cap: null,
  },
  {
    intranetUserId: 117,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 4,
    cap: null,
  },
  {
    intranetUserId: 118,
    allocationSkillId: 19,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 3,
    cap: null,
  },
  {
    intranetUserId: 118,
    allocationSkillId: 20,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 6,
    cap: null,
  },
  {
    intranetUserId: 118,
    allocationSkillId: 21,
    isPrimary: true,
    allocationSkillTypeId: 6,
    numberOfAllocations: 2,
    cap: null,
  },
];
